<app-loading *ngIf="loading" class="animate__animated animate__fadeIn"></app-loading>
<div *ngIf="!loading" class="flex w-full h-screen bg-white animate__animated animate__fadeIn">
    <div class="flex flex-col justify-between w-full min-h-screen">
        <div class="flex flex-col flex-1">
            <app-navbar [data]="data?.navbar"></app-navbar>
            <div (mouseover)="toggleMenu(false)" id="initial">
                <router-outlet></router-outlet>
            </div>
        </div>
        <div class="w-full" (mouseover)="toggleMenu(false)">
            <app-footer [data]="data?.footer"></app-footer>
        </div>
    </div>
</div>